export default __webpack_public_path__ + "static/media/Abstracto.57918226.svg";